import script from "./PageHeaderProject.vue?vue&type=script&setup=true&lang=ts"
export * from "./PageHeaderProject.vue?vue&type=script&setup=true&lang=ts"

import "./PageHeaderProject.vue?vue&type=style&index=0&id=5d939aee&scoped=true&lang=css"

import exportComponent from "/fides/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5d939aee"]])

export default __exports__